import script from "./NotableCollections.vue?vue&type=script&setup=true&lang=js"
export * from "./NotableCollections.vue?vue&type=script&setup=true&lang=js"

export default script